import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { SheetsDisplayGridRowDataFragmentGql } from './SheetsDisplayGridRowFragmentGql';

export const WorkbookDownstreamSheetsQueryGql: DocumentNode = gql`
query WorkbookDownstreamSheetsQuery($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  workbooks(filter: { vizportalUrlId: $workbookVizportalUrlId }) {
    sheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowDataFragment
      }
    }
  }
}
${SheetsDisplayGridRowDataFragmentGql}
`;
